import { LOGO_FULL, LOGO_DIAMOND, NAV } from "@/lib/site";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-[#222] bg-[#050505] pt-20">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid grid-cols-1 gap-12 pb-16 md:grid-cols-3">
          <div className="flex flex-col gap-6">
            <img src={LOGO_FULL} alt="Onarf Marketing" className="h-24 w-auto self-start object-contain" />
            <p className="max-w-xs text-sm leading-relaxed text-white/50">
              Specijalisti isključivo za Meta oglase za poliklinike i ordinacije u Hrvatskoj.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <span className="font-display text-xs font-bold uppercase tracking-[0.2em] text-[#50C878]">Navigacija</span>
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                data-testid={`footer-nav-${n.href.replace("#", "")}`}
                className="flex items-center gap-3 text-sm text-white/60 transition-colors duration-200 hover:text-white"
              >
                <img src={LOGO_DIAMOND} alt="" className="diamond-bullet" />
                {n.label}
              </a>
            ))}
          </div>

          <div className="flex flex-col gap-4">
            <span className="font-display text-xs font-bold uppercase tracking-[0.2em] text-[#50C878]">Kontakt</span>
            <a href="mailto:onarf.marketing@gmail.com" className="text-sm text-white/60 transition-colors hover:text-white">
              onarf.marketing@gmail.com
            </a>
            <a href="tel:+385955985380" className="text-sm text-white/60 transition-colors hover:text-white">
              +385 95 598 5380
            </a>
            <div className="mt-2 flex items-center gap-4">
              <a href="https://instagram.com/onarf_marketing" target="_blank" rel="noopener noreferrer" data-testid="social-instagram" aria-label="Instagram" className="flex items-center gap-2 text-white/50 transition-colors hover:text-[#50C878]"><Instagram size={20} /> <span className="text-sm">@onarf_marketing</span></a>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-start justify-between gap-4 border-t border-[#222] py-8 md:flex-row md:items-center">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} Onarf Marketing. Sva prava pridržana.</p>
          <p className="flex items-center gap-2 text-xs text-white/40">
            <img src={LOGO_DIAMOND} alt="" className="h-3 w-3 object-contain" />
            Meta Business Partner
          </p>
        </div>

        <div className="border-t border-[#161616] py-6" data-testid="legal-company-info">
          <p className="text-[0.7rem] leading-relaxed text-white/30">
            CLEAN-SHINE, obrt za usluge, vl. Ante Budimir · Ulica Franjevačke klasične gimnazije 6 A, Sinj · OIB: 31484132617
          </p>
        </div>
      </div>
    </footer>
  );
}
